<template>
    <span>
        <meusalunos></meusalunos>
    </span>
</template>

<script>
import Meusalunos from '@/components/Meus-Alunos';

export default {
    name: 'cadmeusalunos',
    components: {
        Meusalunos
    }
};
</script>